import React from 'react';
import { connect } from 'react-redux';
import LANGUAGE_CONTROLLER from '../../../controllers/languages';
import { SSelect } from '@avalara/skylab-sdk/react';

const NO_SELECTION = -1;

const CorrectionPeriodSelector = (props) => {

    const onChange = (e) => {
        props.onSelect(e?.detail?.item?.value);
    };

    if (!props.correctionPeriods) {
        return null;
    }

    return (
        <span>
            <span className="divider-left margin-left-sm margin-right-sm"></span>
            <span className="bold">
                <fieldset className="inline">
                    <label className="mr5 uppercase">{LANGUAGE_CONTROLLER.format(props.languages, "filingPage_CorrectionPeriodSelectorLabel")}:</label>
                    <SSelect
                        data-testid="correction-period-select"
                        inputId="correction-period-select"
                        name="correctionPeriod"
                        className="m4"
                        onS-select={onChange}
                        optionsList={[
                            {
                                label: LANGUAGE_CONTROLLER.format(props.languages, "filingPage_CorrectionPeriodSelectorDefault"),
                                value: `${NO_SELECTION}`,
                                selected: `${props.value}` === `${NO_SELECTION}`
                            },
                            ...props.correctionPeriods.map((correctionPeriod, index) => ({
                                label: correctionPeriod.name || correctionPeriod.correctionPeriodName,
                                value: `${index}`,
                                selected: `${props.value}` === `${index}`
                            }))
                        ]}
                        multiple={false}
                        showSelectionCount={false}
                    />
                </fieldset>
            </span>
        </span>
    );

};

function mapStateToProps(state) {
    return {
        correctionPeriods: state.filingCorrections?.correctionPeriods,
        languages: state.languages
    };
}

export default connect(mapStateToProps)(CorrectionPeriodSelector);
